import React, { useState, useContext } from 'react';
import { makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import ReactLoading from 'react-loading';

import { MessageContext } from "../context/message-context";

const useStyles = makeStyles({
  root:{
    paddingTop:80,
    height: 'calc(100vh - 200px)'
  },
  passwordField:{
    width: 310,
  },
  actionButton:{
    color: '#FFFFFF',
    backgroundColor: '#0C4C35',
    '&:hover': {
      color: '#FFFFFF',
      backgroundColor: '#63D764',
    },
    minWidth:120,
    height:32,
  },
  errorTxt:{
    color: '#ff0000',
    fontSize:12
  }


});

export default function PasswordResetInterface(props) {

    const classes = useStyles();
    const [resetIdent] = useState(props.ident);
    const [password, setPassword] = useState('');
    const [passwordRepeat, setPasswordRepeat] = useState('');
    const [hasError, setHasError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [severity, setSeverity] = useState('success');
    const [msg, setMsg] = useState('');
    const [snackOpen, setSnackOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    
  const handleSubmit = (event) => {
    let hasPass = true;
    setHasError(false);
    //Need to put in other password checks here.

    if (password !== passwordRepeat){
      setHasError(true);
      setErrorMsg('Passwords do not match');
      hasPass = false;
    }

    if (password.length <= 7){
      setHasError(true);
      setErrorMsg('Passwords must be at a minimum of 8 characters');
      hasPass = false;
    }

    const regexLetter = /[a-zA-Z]/g;
    if (!regexLetter.test(password)){
      setHasError(true);
      setErrorMsg('Passwords must contain at least 1 letter');
      hasPass = false;
    }

    const regexNumber = /\d/g;
    if (!regexNumber.test(password)){
      setHasError(true);
      setErrorMsg('Passwords must contain at least 1 number');
      hasPass = false;
    }

    if (hasPass){
      //Submit and store the new password.
      setIsLoading(true);
      const abortController = new AbortController();
      const request = {   
        trkid:resetIdent, 
        password:password, 
      };

      let mounted = true;
      (async () => {
        const res = await fetch(process.env.REACT_APP_FIND_API+'/users/reset/password', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(request),
          signal: abortController.signal,
        });
        const data = await res.json();
        if (mounted) {
          if (data.status === "success"){
            setSeverity('success')
            setMsg('Your password has successfully been reset. Please login with your new details.')
          } else {
            setSeverity('error')
            setMsg('Failed to reset your password. Please contact support for further assistances.')
          }
          setIsLoading(false);
          setSnackOpen(true);
        }
      })();
      const cleanup = () => {
         mounted = false;
         abortController.abort();
      };
      return cleanup;

    } else {
      console.log("password failed checks.");
      setIsLoading(false);
    }
  }


  const handleSnackClose=()=>{
    setSnackOpen(false);
    props.close();
  }

    return (
      <div className={classes.root}>
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose}>
            <Alert onClose={handleSnackClose} severity={severity}>
              {msg}
            </Alert>
        </Snackbar>
        <Grid container>
          <Grid item xs={12}>
            <Box p={1} display="flex" justifyContent="center" >
              <Box fontWeight="fontWeightBold" fontSize={18} >Set your new password</Box>
            </Box>
            <Box p={1} display="flex" justifyContent="center">
              <Box fontWeight="fontWeightRegular" fontSize={14} >Type your new password below and confirm by typing it a second time.</Box>
            </Box>
          </Grid>
          <Grid item xs={12}>
          <Box p={1} display="flex" justifyContent="center">
            <TextField type="password" name="password" error={hasError} className={classes.passwordField} label="Please enter your new password" variant="outlined" size="small" margin="dense" value={password} onChange={e => setPassword(e.target.value)} required />
            </Box>
          </Grid>
          <Grid item xs={12}>
          <Box p={1} display="flex" justifyContent="center">
            <TextField type="password" name="passwordrepeat" error={hasError} className={classes.passwordField} label="Please repeat your password" variant="outlined" size="small" margin="dense" value={passwordRepeat} onChange={e => setPasswordRepeat(e.target.value)} required />
          </Box>
            {hasError ? ( <Box p={1} display="flex" justifyContent="center"><Typography className={classes.errorTxt}>{errorMsg}</Typography></Box>) : ( '' )}
          </Grid>
          <Grid item xs={12}>
            <Box p={1} display="flex" justifyContent="center">
            {isLoading ? (
              <Box p={1} justifyContent="center"><ReactLoading className={classes.loadingImg} type={"bars"} color={"#63D764"} /></Box>
            ) : ( 
              <Button className={classes.actionButton} variant="contained" onClick={handleSubmit}>
                <Box fontWeight="fontWeightRegular" fontSize={14} >Change my password</Box>
              </Button>
            )}
            </Box>
          </Grid>
      </Grid>
      </div>
  
    );
  }